/**
 * @generated SignedSource<<4b24c22462684d96e844639c180b4c69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigator_refetchQuery$data = {
  readonly jira: {
    readonly jiraIssueSearchView: {
      readonly __typename: string;
      readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarContainer_view" | "IssueSearchInputProvider_jiraView" | "issueSearch_issueNavigatorGrouping" | "main_issueNavigator_IssueNavigatorUI_jiraView" | "main_issueNavigator_IssueNavigator_detailedViewData" | "main_issueNavigator_IssueNavigator_groupedListViewData" | "main_issueNavigator_IssueNavigator_jiraDetailedViewData" | "main_issueNavigator_IssueNavigator_jiraGroupedListViewData" | "main_issueNavigator_IssueNavigator_jiraListViewData" | "main_issueNavigator_IssueNavigator_listViewData" | "selectedView_issueNavigator_SelectedViewContainer">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigator_refetchQuery";
};
export type main_issueNavigator_IssueNavigator_refetchQuery$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigator_refetchQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_refetchQuery">;
};

import IssueNavigatorIssueSearchRefetchQuery_graphql from './IssueNavigatorIssueSearchRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isConditionalFormattingEnabled",
  "variableName": "isConditionalFormattingEnabled"
},
v1 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "projectKeys",
  "variableName": "projectKeys"
},
v3 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v5 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "shouldQueryHasChildren",
    "variableName": "shouldQueryHasChildren"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "dynamicSearchKey"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "kind": "RootArgument",
      "name": "filterId"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "jiraViewQueryInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "namespace"
    },
    {
      "kind": "RootArgument",
      "name": "options"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "saveJQLToUserHistory"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "shouldQueryHasChildren"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    },
    {
      "kind": "RootArgument",
      "name": "viewId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": IssueNavigatorIssueSearchRefetchQuery_graphql
    }
  },
  "name": "main_issueNavigator_IssueNavigator_refetchQuery",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "filterId",
              "variableName": "filterId"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "jiraViewQueryInput",
              "variableName": "jiraViewQueryInput"
            },
            {
              "kind": "Variable",
              "name": "namespace",
              "variableName": "namespace"
            },
            {
              "kind": "Variable",
              "name": "scope",
              "variableName": "scope"
            },
            {
              "kind": "Variable",
              "name": "settings",
              "variableName": "settings"
            },
            {
              "kind": "Variable",
              "name": "viewConfigInput",
              "variableName": "staticViewInput"
            },
            {
              "kind": "Variable",
              "name": "viewId",
              "variableName": "viewId"
            }
          ],
          "kind": "LinkedField",
          "name": "jiraIssueSearchView",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "FragmentSpread",
              "name": "IssueSearchInputProvider_jiraView"
            },
            {
              "kind": "FragmentSpread",
              "name": "issueSearch_issueNavigatorGrouping"
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "isSavedViewConditionalFormattingEnabled",
                  "variableName": "isSavedViewConditionalFormattingEnabled"
                }
              ],
              "kind": "FragmentSpread",
              "name": "main_issueNavigator_IssueNavigatorUI_jiraView"
            },
            {
              "kind": "FragmentSpread",
              "name": "selectedView_issueNavigator_SelectedViewContainer"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "condition": "isSavedViewConditionalFormattingEnabled",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 20
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ConditionalFormattingSidebarContainer_view"
                    }
                  ]
                }
              ],
              "type": "JiraSpreadsheetView",
              "abstractKey": "__isJiraSpreadsheetView"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": (v3/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_jiraDetailedViewData"
                    }
                  ]
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": (v3/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                    }
                  ]
                }
              ],
              "type": "JiraDetailedView"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": (v4/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData"
                    }
                  ]
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": (v4/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                    }
                  ]
                }
              ],
              "type": "JiraGroupedListView"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": (v5/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_jiraListViewData"
                    }
                  ]
                },
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraninlastusedjqlrelayprovider",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": (v5/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "main_issueNavigator_IssueNavigator_listViewData"
                    }
                  ]
                }
              ],
              "type": "JiraListView"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "890906db4f5f0af8b4eb588379287a51";

export default node;
